/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NaicsCodes
 */
export interface NaicsCodes {
}

/**
 * Check if a given object implements the NaicsCodes interface.
 */
export function instanceOfNaicsCodes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NaicsCodesFromJSON(json: any): NaicsCodes {
    return NaicsCodesFromJSONTyped(json, false);
}

export function NaicsCodesFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaicsCodes {
    return json;
}

export function NaicsCodesToJSON(value?: NaicsCodes | null): any {
    return value;
}

